




























































































































import { Component, Vue, Prop, Watch, Model } from "vue-property-decorator";
import {
  Meter,
  ResCode,
  PowerConditionerTableData,
  ChartItem,
  MeterChartData,
  MeterChartDatas,
} from "@/api/baseDefine";
import LineChart from "@/components/chart/MeterLineChart.vue";
import {
  SendDataReq,
  sendData,
  meters,
  GetPowerConditionerDataReq,
  getPowerConditionerData,
  PowerConditioner,
} from "@/api/meter";
import {
  formatDate,
  formatDateTime,
  formatHour,
  formatMonth,
  formatYear,
} from "../../utils/dateUtil";
import { GetMeterReq, getMeterData, History } from "@/api/home";
@Component({
  components: {
    LineChart,
  },
})
export default class MeterChatDialog extends Vue {
  private meter: Meter = <Meter>{};
  private timeArray: string[] = [];
  private chartType: ChartItem = <ChartItem>{};
  private selectDate = formatDate(new Date());
  private dialogChart: boolean = false;
  private chartUsages: ChartItem[] = [];
  private chartUsagesList: ChartItem[][][] = [];
  private pvUsageTitle: ChartItem[] = [];
  private powerUsageTitle: ChartItem[] = [];
  private subPowerUsageTitles: ChartItem[] = [];
  private otherUsageTitles: ChartItem[] = [];
  private currentChartItems: ChartItem[] = [];
  private currentLeftChartItems: ChartItem[] = [];
  private currentRightChartItems: ChartItem[] = [];
  private chartTileName: string = "";
  private chartPage: number = 0;
  private unit: string = "";
  private meterTypeUnits: string[] = ["m³", "kWh", "m³", "MWh", "kWh"];
  private time = "";
  private lineData: boolean = true;
  private lineChartData: MeterChartDatas = <MeterChartDatas>{};
  private rightRadioType = -1;
  private leftTitle: string = "";
  private rightTitle: string = "";
  private leftMaxNumber: string = "";
  private leftMinNumber: string = "";
  private leftAvgNumber: string = "";
  private rightMaxNumber: string = "";
  private rightMinNumber: string = "";
  private rightAvgNumber: string = "";
  private leftUnit: string = "";
  private rightUnit: string = "";
  private async onLeftItemChange(check: boolean, type: number) {
    if (this.lists.length > 0) {
      await this.dealResData(this.lists);
      let lineChatRef = this.$refs.lineChatRef as any;
      lineChatRef.onChangeValue(this.lineChartData);
    } else {
      this.showChart();
    }
  }

  private async onRadioChange() {
    if (this.lists.length > 0) {
      await this.dealResData(this.lists);
      let lineChatRef = this.$refs.lineChatRef as any;
      lineChatRef.onChangeValue(this.lineChartData);
    } else {
      this.showChart();
    }
  }
  private clickShow(meter: Meter) {
    this.init();
    this.lineChartData = <MeterChartDatas>{};
    this.lineChartData.letfTitleArray = [];
    this.meter = meter;
    for (let item of this.chartUsages) {
      if (!item.unit) {
        item.unit = this.meterTypeUnits[this.meter.meterTypeID - 1];
      }
      this.mapTypeChartItem.set(item.type, item);
    }
    this.dialogChart = true;
    this.chartType = this.chartUsages[0];
    this.dialogChart = true;
    this.lineData = true;
    this.chartPage = 0;
    this.currentChartItems = this.chartUsagesList[this.meter.meterTypeID - 1][
      this.meter.subMeterTypeIndex
    ];
    this.currentLeftChartItems = [];
    this.currentRightChartItems = [];
    for (let item of this.currentChartItems) {
      if (item.left) {
        // item.check = false;
        this.currentLeftChartItems.push(item);
      } else {
        this.currentRightChartItems.push(item);
      }
    }
    if (this.currentRightChartItems.length > 0) {
      this.rightRadioType = this.currentRightChartItems[0].type;
    }

    this.selectDate = formatDate(new Date());
    this.showChart();
  }

  private lists: History[] = [];
  /**
   * 初始化或者有什么设置上的变化时调用该方法
   */
  public async showChart(selectDateFlag?: boolean) {
    if (this.dialogChart == false) {
      return;
    }

    let date: Date = new Date();
    if (!!this.selectDate) {
      date = new Date(this.selectDate);
    }
    console.log("showChart", date.getTime());
    let timeID = this.timeArray.indexOf(this.time);
    timeID = timeID + 1;
    date = this.getDate(date, timeID, selectDateFlag);
    console.log("showChart", date.getTime());
    let req = <GetMeterReq>{
      meterID: this.meter.id,
      timeID: timeID,
      date: formatDateTime(date),
      type: 0,
      lineData: this.lineData,
    };
    const res = await getMeterData(req);
    if (res.code === ResCode.SUCCESS) {
      this.chartPage = 0;
      this.selectDate = req.date;
      this.lists = res.data.history.list;
      await this.dealResData(this.lists);
      let lineChatRef = this.$refs.lineChatRef as any;
      lineChatRef.onChangeValue(this.lineChartData);
    }
  }

  /**
   * 处理返回的数据
   */
  public async dealResData(lists: History[]) {
    this.lineChartData.xDatas = [];
    this.lineChartData.leftDatas = [];
    this.lineChartData.rightDatas = [];
    this.lineChartData.leftName = "";
    for (let history of lists) {
      this.lineChartData.xDatas.push(this.formatHistoryTime(history));
    }
    let leftTitles: string[] = [];
    for (let chartItem of this.currentChartItems) {
      if (!chartItem.check && this.rightRadioType != chartItem.type) {
        continue;
      }
      this.getHistoryByType(lists, chartItem.type);
      if (this.rightRadioType == chartItem.type) {
        this.lineChartData.rightName = chartItem.title;
        this.lineChartData.rightUnit = chartItem.unit;
      } else {
        leftTitles.push(chartItem.title);
        this.lineChartData.leftName =
          this.lineChartData.leftName + " " + chartItem.title;
        this.lineChartData.leftUnit = chartItem.unit;
      }
    }
    for (let i = 0; i < this.lineChartData.letfTitleArray.length; i++) {
      if (leftTitles.indexOf(this.lineChartData.letfTitleArray[i]) < 0) {
        this.lineChartData.letfTitleArray.splice(i, 1);
      }
    }

    for (let i = 0; i < leftTitles.length; i++) {
      if (this.lineChartData.letfTitleArray.indexOf(leftTitles[i]) < 0) {
        this.lineChartData.letfTitleArray.push(leftTitles[i]);
      }
    }

    if (this.lineChartData.leftDatas.length == 1) {
      this.lineChartData.firstLeftName = this.lineChartData.leftDatas[0].name;
    }

    this.dealData();
  }

  private getHistoryByType(lists: History[], type: number) {
    let chartItem: ChartItem | undefined = this.mapTypeChartItem.get(type);
    if (!chartItem) {
      return;
    }
    let meterChartYdatas: MeterChartData[] = [];
    let meterChartYdata: MeterChartData = <MeterChartData>{};
    let meterChartYdata1: MeterChartData = <MeterChartData>{};
    let meterChartYdata2: MeterChartData = <MeterChartData>{};
    meterChartYdata.yDatas = [];
    meterChartYdata1.yDatas = [];
    meterChartYdata2.yDatas = [];
    meterChartYdata.name = chartItem.title;
    meterChartYdata1.name = chartItem.title;
    meterChartYdata2.name = chartItem.title;
    meterChartYdata.unit = chartItem.unit;
    meterChartYdata1.unit = chartItem.unit;
    meterChartYdata2.unit = chartItem.unit;
    for (let history of lists) {
      if (type === 0) {
        meterChartYdata.yDatas.push(history.usage);
      } else if (type === 1) {
        meterChartYdata.yDatas.push(history.importEnergyUsage);
      } else if (type === 2) {
        meterChartYdata.yDatas.push(history.exportEnergyUsage);
      } else if (type === 3) {
        meterChartYdata.yDatas.push(history.pvEnergyUsage);
      } else if (type === 4) {
        meterChartYdata.yDatas.push(history.pulseCountUsage);
      } else if (type === 5) {
        if (this.lineData) {
          meterChartYdata.yDatas.push(history.lineDatas[0]);
        } else {
          meterChartYdata.yDatas.push(history.Current1);
        }
      } else if (type === 6) {
        if (this.lineData) {
          meterChartYdata.yDatas.push(history.lineDatas[1]);
        } else {
          meterChartYdata.yDatas.push(history.Voltage1);
        }
      } else if (type === 7) {
        if (this.lineData) {
          meterChartYdata.yDatas.push(history.lineDatas[2]);
        } else {
          meterChartYdata.yDatas.push(history.Frequency1);
        }
      } else if (type === 8) {
        if (this.lineData) {
          meterChartYdata.yDatas.push(history.lineDatas[3]);
        } else {
          meterChartYdata.yDatas.push(history.ActivePower1);
        }
      } else if (type === 9) {
        if (this.lineData) {
          meterChartYdata.yDatas.push(history.lineDatas[4]);
        } else {
          meterChartYdata.yDatas.push(history.ReactivePower1);
        }
      } else if (type === 10) {
        meterChartYdata.yDatas.push(history.pyranometerUsage);
      } else if (type === 11) {
        meterChartYdata.yDatas.push(history.temperature);
      } else if (type === 12) {
        meterChartYdata.yDatas.push(history.humidity);
      } else if (type === 13) {
        if (this.meter.meterTypeID == 5) {
          meterChartYdata.yDatas.push(history.importEnergyUsage);
        } else {
          meterChartYdata.yDatas.push(history.routeBImportEnergyUsage);
        }
      } else if (type === 14) {
        if (this.meter.meterTypeID == 5) {
          meterChartYdata.yDatas.push(history.exportEnergyUsage);
        } else {
          meterChartYdata.yDatas.push(history.routeBExportEnergyUsage);
        }
      } else if (type === 15) {
        if (this.lineData) {
          meterChartYdata.yDatas.push(history.lineDatas[5]);
        } else {
          meterChartYdata.yDatas.push(history.Current2);
        }
      } else if (type === 16) {
        if (this.lineData) {
          meterChartYdata.yDatas.push(history.lineDatas[6]);
        } else {
          meterChartYdata.yDatas.push(history.Voltage2);
        }
      } else if (type === 17) {
        if (this.lineData) {
          meterChartYdata1.yDatas.push(history.lineDatas[7]);
        } else {
          meterChartYdata1.yDatas.push(history.Frequency2);
        }
      } else if (type === 18) {
        if (this.lineData) {
          meterChartYdata1.yDatas.push(history.lineDatas[8]);
        } else {
          meterChartYdata1.yDatas.push(history.ActivePower2);
        }
      } else if (type === 19) {
        if (this.lineData) {
          meterChartYdata1.yDatas.push(history.lineDatas[9]);
        } else {
          meterChartYdata1.yDatas.push(history.ReactivePower2);
        }
      } else if (type === 20) {
        meterChartYdata.yDatas.push(history.pvExportEnergyUsage);
      }
    }

    if (meterChartYdata.yDatas.length > 0) {
      meterChartYdatas.push(meterChartYdata);
    }
    if (meterChartYdata1.yDatas.length > 0) {
      meterChartYdatas.push(meterChartYdata1);
    }
    if (meterChartYdata2.yDatas.length > 0) {
      meterChartYdatas.push(meterChartYdata2);
    }
    if (!!chartItem.left) {
      this.lineChartData.leftDatas = this.lineChartData.leftDatas.concat(
        meterChartYdatas
      );
    } else {
      this.lineChartData.rightDatas = this.lineChartData.rightDatas.concat(
        meterChartYdatas
      );
    }
  }

  private dealData() {
    let leftMinNumber = 999999999;
    let leftMaxNumber = 0;
    let leftAvgNumber = 0;
    let rightMaxNumber = 0;
    let rightMinNumber = 999999999;
    let rightAvgNumber = 0;
    this.leftTitle = "";
    this.leftUnit = "";

    if (this.lineChartData.leftDatas.length > 0) {
      console.log("1111111111", this.lineChartData);
      for (let leftMeterChartData of this.lineChartData.leftDatas) {
        if (this.lineChartData.letfTitleArray[0] == leftMeterChartData.name) {
          let sum = 0;
          let index = 0;
          for (let i = 0; i < leftMeterChartData.yDatas.length; i++) {
            let d = leftMeterChartData.yDatas[i];
            index++;
            sum += d;
            if (d > leftMaxNumber) {
              leftMaxNumber = d;
            } else if (d < leftMinNumber) {
              leftMinNumber = d;
            }
          }
          leftAvgNumber = sum / index;
          this.leftUnit = leftMeterChartData.unit;
          this.leftTitle = leftMeterChartData.name;
        }
      }
    } else {
      leftMinNumber = 0;
    }

    if (this.lineChartData.rightDatas.length > 0) {
      let sum = 0;
      let index = 0;
      let rightMeterChartData: MeterChartData = this.lineChartData
        .rightDatas[0];
      for (let i = 0; i < rightMeterChartData.yDatas.length; i++) {
        let d = rightMeterChartData.yDatas[i];
        if (!d) {
          continue;
        }
        index++;
        sum += d;
        if (d > rightMaxNumber) {
          rightMaxNumber = d;
        } else if (d < rightMinNumber) {
          rightMinNumber = d;
        }
      }
      this.rightUnit = this.lineChartData.rightUnit;
      this.rightTitle = this.lineChartData.rightName;
      if (index == 0) {
        rightAvgNumber = 0;
        rightMinNumber = 0;
      } else {
        rightAvgNumber = sum / index;
      }
    }

    if (leftMinNumber == 999999999) {
      leftMinNumber = 0;
    }
    if (rightMinNumber == 999999999) {
      rightMinNumber = 0;
    }
    this.leftMinNumber = leftMinNumber.toFixed(4);
    this.leftMaxNumber = leftMaxNumber.toFixed(4);
    this.leftAvgNumber = leftAvgNumber.toFixed(4);
    this.rightMaxNumber = rightMaxNumber.toFixed(4);
    this.rightMinNumber = rightMinNumber.toFixed(4);
    this.rightAvgNumber = rightAvgNumber.toFixed(4);
  }
  public async next() {
    let date = new Date();
    date = new Date(
      date.getFullYear(),
      date.getMonth(),
      date.getDate() + this.chartPage * 7,
      0
    );
    if (
      !!this.selectDate &&
      date.getTime() - new Date(this.selectDate).getTime() < 1 * 60 * 60 * 1000
    ) {
      this.$notify({
        title: this.$t("common.warning").toString(),
        message: this.$t("notification.alreadyLastPage").toString(),
        type: "warning",
      });
      return;
    }
    this.chartPage++;
    this.showChart();
  }

  public async pre() {
    this.chartPage--;
    this.showChart();
  }
  public selectDateChange() {
    this.showChart(true);
  }

  private mapTypeChartItem: Map<number, ChartItem> = new Map();
  private init() {
    this.chartUsages = [
      {
        title: this.$t("usage.usage").toString(),
        type: 0,
        left: true,
        check: true,
        unit: "",
      },
      {
        title: this.$t("usage.importEngery").toString(),
        type: 1,
        left: true,
        check: false,
        unit: "",
      },
      {
        title: this.$t("usage.exportEnergy").toString(),
        type: 2,
        left: true,
        check: false,
        unit: "",
      },
      {
        title: this.$t("usage.pVEnergy").toString(),
        type: 3,
        left: true,
        check: false,
        unit: "",
      },
      {
        title: this.$t("usage.pulseCountUsage").toString(),
        type: 4,
        left: false,
        check: false,
        unit: "Pulse",
      },
      {
        title: this.$t("usage.current1").toString(),
        type: 5,
        left: false,
        check: false,
        unit: "A",
      },
      {
        title: this.$t("usage.voltage1").toString(),
        type: 6,
        left: false,
        check: false,
        unit: "V",
      },
      {
        title: this.$t("usage.frequency1").toString(),
        type: 7,
        left: false,
        check: false,
        unit: "HZ",
      },
      {
        title: this.$t("usage.activePower1").toString(),
        type: 8,
        left: false,
        check: false,
        unit: "kW",
      },
      {
        title: this.$t("usage.reactivePower1").toString(),
        type: 9,
        left: false,
        check: false,
        unit: "kVar",
      },
      {
        title: this.$t("usage.pyranometer").toString(),
        type: 10,
        left: false,
        check: false,
        unit: "W/m2",
      },
      {
        title: this.$t("usage.temperature").toString(),
        type: 11,
        left: false,
        check: false,
        unit: "°C",
      },
      {
        title: this.$t("usage.humidity").toString(),
        type: 12,
        left: false,
        check: false,
        unit: "%",
      },
      {
        title: this.$t("usage.routeBImportEnergy").toString(),
        type: 13,
        left: true,
        check: false,
        unit: "kWh",
      },
      {
        title: this.$t("usage.routeBExportEnergy").toString(),
        type: 14,
        left: true,
        check: false,
        unit: "kWh",
      },
      {
        title: this.$t("usage.current2").toString(),
        type: 15,
        left: false,
        check: false,
        unit: "A",
      },
      {
        title: this.$t("usage.voltage2").toString(),
        type: 16,
        left: false,
        check: false,
        unit: "V",
      },
      {
        title: this.$t("usage.frequency2").toString(),
        type: 17,
        left: false,
        check: false,
        unit: "HZ",
      },
      {
        title: this.$t("usage.activePower2").toString(),
        type: 18,
        left: false,
        check: false,
        unit: "kW",
      },
      {
        title: this.$t("usage.reactivePower2").toString(),
        type: 19,
        left: false,
        check: false,
        unit: "kVar",
      },
      {
        title: this.$t("usage.pvExportEnergyUsage").toString(),
        type: 20,
        left: true,
        check: false,
        unit: "",
      },
    ];

    this.chartType = this.chartUsages[0];

    let powerUsageTitle = [
      this.chartUsages[0],
      this.chartUsages[1],
      this.chartUsages[2],
      this.chartUsages[4],
      this.chartUsages[5],
      this.chartUsages[6],
      this.chartUsages[7],
      this.chartUsages[8],
      this.chartUsages[9],
      this.chartUsages[13],
      this.chartUsages[14],
      this.chartUsages[15],
      this.chartUsages[16],
      this.chartUsages[17],
      this.chartUsages[18],
      this.chartUsages[19],
    ];
    let subPowerUsageTitles = [
      this.chartUsages[0],
      this.chartUsages[1],
      this.chartUsages[2],
      this.chartUsages[4],
      this.chartUsages[5],
      this.chartUsages[6],
      this.chartUsages[7],
      this.chartUsages[8],
      this.chartUsages[9],
      this.chartUsages[18],
      this.chartUsages[19],
      this.chartUsages[15],
      this.chartUsages[16],
      this.chartUsages[17],
      this.chartUsages[13],
      this.chartUsages[14],
    ];
    let pvUsageTitle = [
      this.chartUsages[0],
      this.chartUsages[13],
      this.chartUsages[14],
      this.chartUsages[3],
      this.chartUsages[4],
      this.chartUsages[5],
      this.chartUsages[6],
      this.chartUsages[7],
      this.chartUsages[15],
      this.chartUsages[16],
      this.chartUsages[17],
      this.chartUsages[8],
      this.chartUsages[9],
      this.chartUsages[18],
      this.chartUsages[19],
      this.chartUsages[10],
      this.chartUsages[11],
      this.chartUsages[12],
    ];
    let pvUsageTitle1 = [
      this.chartUsages[0],
      this.chartUsages[13],
      this.chartUsages[14],
      this.chartUsages[3],
      this.chartUsages[4],
      this.chartUsages[5],
      this.chartUsages[6],
      this.chartUsages[7],
      this.chartUsages[15],
      this.chartUsages[16],
      this.chartUsages[17],
      this.chartUsages[8],
      this.chartUsages[9],
      this.chartUsages[18],
      this.chartUsages[19],
      this.chartUsages[20],
      this.chartUsages[11],
      this.chartUsages[12],
    ];
    this.otherUsageTitles = [this.chartUsages[0]];

    this.chartUsagesList = [
      [[this.chartUsages[0]]],
      [powerUsageTitle, powerUsageTitle, powerUsageTitle, subPowerUsageTitles],
      [[this.chartUsages[0]]],
      [[this.chartUsages[0]]],
      [pvUsageTitle, pvUsageTitle1],
    ];
    this.timeArray = [
      this.$t("timeArray.hours").toString(),
      this.$t("timeArray.days").toString(),
      this.$t("timeArray.weeks").toString(),
      this.$t("timeArray.months").toString(),
      this.$t("timeArray.years").toString(),
    ];
    this.time = this.timeArray[0];
  }

  private formatHistoryTime(history: History): string {
    let timeID = this.timeArray.indexOf(this.time);
    timeID = timeID + 1;
    let time = history.time;
    let times = time.split(" ");
    if (timeID == 1) {
      time = formatHour(new Date(time));
    } else if (timeID == 2) {
      time = times[0];
    } else if (timeID == 3) {
      time = times[0];
    } else if (timeID == 4) {
      time = formatMonth(new Date(time));
    } else {
      time = formatYear(new Date(time));
    }
    return time;
  }

  private getDate(date: Date, timeID: number, selectDateFlag?: boolean) {
    if (!selectDateFlag) {
      if (timeID === 1) {
        date = new Date(
          date.getFullYear(),
          date.getMonth(),
          date.getDate() + this.chartPage,
          0
        );
      } else if (timeID === 2) {
        date = new Date(
          date.getFullYear(),
          date.getMonth(),
          date.getDate() + this.chartPage * 7,
          0
        );
      } else if (timeID === 3) {
        date = new Date(
          date.getFullYear(),
          date.getMonth(),
          date.getDate() + this.chartPage * 28,
          0
        );
      } else if (timeID === 4) {
        date = new Date(
          date.getFullYear(),
          date.getMonth() + this.chartPage * 1,
          date.getDate(),
          0
        );
      } else if (timeID === 5) {
        date = new Date(
          date.getFullYear() + this.chartPage * 5,
          date.getMonth(),
          date.getDate(),
          0
        );
      }
    } else {
      date = new Date(this.selectDate);
      date.setHours(new Date().getHours());
    }
    return date;
  }
}
